import React from 'react';

const Footer = () => {
  return (
    <footer className="vitrine-footer px-3 px-sm-5">
      <div className="row">
        <div className="col-12 col-lg-6 px-2 px-sm-0 copyright text-center text-lg-left">
          <div className="row">
            <span className="footer-copyright">
              Copyright © 2025 - trading.
              Todos os direitos reservados.
            </span>
          </div>
        </div>
        <div className="col-12 col-lg-6 px-2 px-sm-0 support align-items-center align-items-md-end justify-content-center flex-column">
          <div className="d-flex flex-column flex-md-row align-items-center">
            <a 
              className="mx-2 ml-lg-4 mr-lg-0" 
              href="https://compliance.cademi.com.br/termos-de-uso" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {/* Termos de Uso */}
            </a>
            <a 
              className="mx-2 ml-lg-4 mr-lg-0" 
              href="https://compliance.cademi.com.br/politica-de-privacidade-lgpd" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {/* Política de Privacidade */}
            </a>
            <a className="mx-2 ml-lg-4 mr-lg-0" href="/area/eu/suporte">
              {/* Suporte */}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
